"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.default = React.createContext({
    onButtonClick: null,
    activeButtonName: null,
    flat: false,
    disabled: false
});
